import { Component, OnInit, ViewChild, Inject, Input, HostListener, OnDestroy, Optional, Output, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BsoSpecialInstructions, ClientList, UpdatePrehold } from '@EfsModels/efs.model';
// import { TableDirective } from '@EfsDirectives/table.directive';
// import { ReusableTableComponent } from '@EfsReusable/reusable-table/reusable-table.component';
import { EfsApiService } from '@EfsServices/efs-api.service';
import { LoggingService } from '@EfsServices/logging.service';
import { GenericPopupComponent } from '@EfsReusable/generic-popup/generic-popup.component';
import { GuardLinkService } from '@EfsServices/guard-link.service';
import { DataSharingService } from '@EfsServices/data-sharing.service';
import { SessionTimerService } from '@EfsServices/session-timer.service';
import { ApiErrorHandlingService } from '@EfsServices/api-error-handling.service';
import { saveAs } from 'file-saver';
import { ReusableTableComponent, TypeaheadSearchComponent, CorpSearchComponent } from '@nextgen/components-lib';
import { Subject } from 'rxjs';

import { environment } from '@efsEnvironments/environment';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'app-ruleSetup-list-corps',
    templateUrl: './ruleSetup-list-corps.component.html',
    styleUrls: ['./common-list-corps.component.css'],
    standalone: false
})
export class RuleSetupListCorpsComponent implements OnInit, OnDestroy {

  // receive the module name from the component that calls this component
  hideLoader = false;
  hidePage = true;
  moduleName = '';
  moduleTitle = '';
  @ViewChild('table0', { static: true }) reusableTable0: ReusableTableComponent;
  @ViewChild('table1', { static: true }) reusableTable1: ReusableTableComponent;
  @ViewChild('search0', { static: true }) searchComponent: TypeaheadSearchComponent;
  @ViewChild('fromCorp', { static: true }) fromCorpComponent: CorpSearchComponent;
  @ViewChild('toCorp', { static: true }) toCorpComponent: CorpSearchComponent;
  public tableEventSubject: Subject<any> = new Subject<any>();
  public table1EventSubject: Subject<any> = new Subject<any>();
  public clientEventSubject: Subject<any> = new Subject<any>();
  public fromEventSubject: Subject<any> = new Subject<any>();
  public toEventSubject: Subject<any> = new Subject<any>();
  message;
  searchMessage;
  messageObject;
  componentRef;
  popupDialogRef;

  viewOnlyMode = false;

  ruleClassId;

  contexts = [];

  searchComponentMessage = '';

  checkboxHeader = '\u00a0\u00a0';
  pageSizeOptions = [25, 50, 75];

  table0rowData;
  table1rowData;

  corpList = [];

  ruleStatus = '';
  ruleDescription = '';
  ruleName = '';

  assocFilterControl = new UntypedFormControl('');
  rightSideAvailFilterControl = new UntypedFormControl('');

  facilityControl = new UntypedFormControl('');
  faciliyDisabled = true;
  toggleAllSelected = false;
  facilitiesToHold: any = [];
  facilityCds = [];
  facilityIds = [];
  selectedFacilityId = 'null'; // default value
  facilityIdSearchValue = 'null'; // default value for all facilities
  allSelectedValue = [{ name: 'All Selected' }];

  // get the non generic data and make it generic
  // rowData = {
  //   templateId: '',
  //   templateDesc: '',
  //   bsoTemplateDetailList: [],
  // };

  searchJson = {
    templateId: '',
    associatedCorps: [],
    targetClientId: 'null',
    disAssociatedFromCorpCd: '',
    disAssociatedToCorpCd: '',
    facilityId: 'null',
  };
  updateListCorps = {
    templateId: '',
    description: '',
    detailsAdded: [],
    detailsRemoved: [],
    detailsUpdated: [],
    corpsAdded: [],
    corpsRemoved: [],
    facilitiesAdded: [],
    facilitiesRemoved: [],
  };

  ruleContexts;

  updateRuleRequest = {
    ruleNm: '',
    ruleDesc: '',
    listCorpRuleContextAdd: [],
    contexts_reject: [],
    contexts_retire: []
  };

  contextsAdd: {
    blnktSlsOrderCd: string,
    facilityId: number,
    clientId: number,
  };
  contextsReject: [];
  contextsRetire: [];

  clients: ClientList[] = [];
  bsoTemplateDetailList;
  bsoTemplateDetailListCopy;
  bsoCodeAssocIds = [];
  fromCorp = 'null';
  toCorp = 'null';
  availCorpsTable = [];
  assocCorpsTable = [];

  hasSearchOccured = false;
  saveOccured = false;
  saveStatus = false;

  toggleSaveButton = true;
  toggleDiscButton = false;
  toggleAsscButton = false;
  showXButton = true;

  effectiveDate;
  fromCorpValue;
  toCorpValue;
  clientId = 'null';
  searchClientId = null;
  clientName;
  clientNameDisp = '';
  fromCorpDisp;
  toCorpDisp;
  templateDesc;
  statesToHold;
  @Input() templateData = { templateDesc: '', statesToHold: [] }; // when not a popup, get data from parent

  // list of assigned facilities
  assignedFacilitiesToCorpsList = [];

  // define the columns in the table
  columns = [
    { columnDef: 'select', header: 'S', cell: (element: BsoSpecialInstructions) => `${element.blnktSlsOrderId}` },
    // { columnDef: 'index', header: 'index', cell: (element: any) => `${element.index}` },
    { columnDef: 'blnktSlsOrderCd', header: 'Corp', cell: (element: any) => `${element.blnktSlsOrderCd}` },
    // { columnDef: 'facility.facilityCd', header: 'Facility', cell: (element: any) => `${element.facilityCd}` },
    // { columnDef: 'clientId', header: 'Client ID', cell: (element: any) => `${element.clientId}` },
    { columnDef: 'clientNm', header: 'Client', cell: (element: any) => `${element.clientNm}` },
  ];
  displayedColumns = this.columns.map(c => c.columnDef);

  columns1 = [
    { columnDef: 'select', header: 'S', cell: (element: BsoSpecialInstructions) => `${element.blnktSlsOrderId}` },
    // { columnDef: 'index', header: 'index', cell: (element: any) => `${element.index}` },
    {
      columnDef: 'blnktSlsOrderCd',
      header: 'Corp', cell: (element: any) => `${element.blnktSlsOrderCd}`
    },
    // { columnDef: 'facilityCd', header: 'Facility', cell: (element: any) => `${element.facilityCd}` },
    // {
    //   columnDef: 'bsoTemplateDetailList.clientId', header: 'Client ID',
    //   cell: (element: any) => `${element.clientId}`
    // }
    { columnDef: 'clientNm', header: 'Client', cell: (element: any) => `${element.clientNm}` },
  ];
  displayedColumns1 = this.columns1.map(c => c.columnDef);

  constructor(
    private dataSharingService: DataSharingService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    // private componentFactoryResolver: ComponentFactoryResolver,
    private efsApiService: EfsApiService,
    private loggingService: LoggingService,
    @Optional() public dialogRef: MatDialogRef<RuleSetupListCorpsComponent>,
    public dialog: MatDialog,
    private guardLinkService: GuardLinkService,
    private sessionTimerService: SessionTimerService,
    private apiErrorHandlingService: ApiErrorHandlingService,
    private ref: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.loadTableComponent();
    this.filterAssocCorps();
    this.rightFilterControl();
    // set the help button
    this.dataSharingService.shareData('rulesetup');
    // listen for close requests from the main app
    const channel = new BroadcastChannel('commonListCorps');
    channel.postMessage('ListCorpsLoaded');
    channel.onmessage = ((message) => {
      console.log('received from main app ' + JSON.stringify(message.data));
      if (message.data === 'closeTab') { // SEND CLOSE IF TRYING TO OPEN TOO MANY
        console.log('closeTab received, close window');
        this.cancelButton();
        return;
      } else {
        this.data = message.data;
        console.log('what is data? ' + JSON.stringify(this.data));
        // this.serviceGetFacilities(); // facilities are not a choice currently
        this.serviceGetRuleContextByRuleId();
      }
      this.ruleClassId = this.data.templateData.ruleClassId;
      this.moduleTitle = this.data.moduleTitle;
      this.moduleName = this.data.moduleName;
      // set view only mode
      if (this.data.viewOnlyMode === true) {
         // grey out the buttons when in this mode
         document.getElementById('exportButton').style.background = '#808080'; // turns button grey

        this.viewOnlyMode = true;
        this.searchComponent.searchControl.disable();
        this.fromCorpComponent.fromCorpControl.disable();
        this.toCorpComponent.toCorpControl.disable();
      } else {
        this.viewOnlyMode = false;
      }

      // now that it is loaded, do all the setup
      this.loggingService.logInfo('user is in list corps setup');
      try {
        this.showXButton = this.data.popUp;
      } catch {
        console.log('Not a popup');
      }
      console.log('LIST CORPS ' + JSON.stringify(this.data.templateData));
      // data is not generic, use a filter to treat the data generically until it needs to be consumed by a service,
      // at which point it will be re-identified. this will be based on the moduleName variable
      this.genericizeData();
      console.log(JSON.stringify(this.data.templateData));

      this.setValues();
      // this.loadToCorpComponent();

      // if (this.templateData.templateDesc !== '') { // set data if not a popup
      //   console.log('TEMPLATE DATA FROM PARENT ' + JSON.stringify(this.templateData));
      //   this.templateDesc = this.templateData.templateDesc;
      //   this.statesToHold = this.templateData.statesToHold.join(', ');
      //   this.data.templateData.templateId = sessionStorage.getItem('templateId');
      //   this.updateListCorps.templateId = sessionStorage.getItem('templateId');
      // }

      // this.serviceGettemplateCorps(); // now launched at service get facilities
      // this.serviceDataSharing();

      // disable from and to corp if client search box has input, vis versa for client
      this.searchComponent.searchControl.valueChanges.subscribe(input => {
        console.log(input);
        try {
          if (input.length > 0) {
            this.fromCorpComponent.fromCorpControl.setValidators([
              Validators.pattern('[a-zA-Z0-9]*'),
              Validators.maxLength(5),
              Validators.minLength(0),
            ]);
            this.fromCorpComponent.fromCorpControl.updateValueAndValidity();
            // this.fromCorpComponent.fromCorpControl.reset();
            // this.fromCorp = 'null';
            // this.fromCorpComponent.toCorpControl.reset();
            // this.toCorp = 'null';
            // this.fromCorpComponent.fromCorpControl.disable();
            // this.toCorpComponent.toCorpControl.disable();
          } else {
            this.fromCorpComponent.fromCorpControl.setValidators([
              Validators.pattern('[a-zA-Z0-9]*'),
              Validators.maxLength(5),
              Validators.minLength(0),
            ]);
            this.fromCorpComponent.fromCorpControl.updateValueAndValidity();
            // this.fromCorpComponent.fromCorpControl.enable();
            // this.toCorpComponent.toCorpControl.enable();
          }
        } catch {
          console.log('input undefined');
        }
      });

      this.fromCorpComponent.fromCorpControl.valueChanges.subscribe(input => {
        console.log(input);
        // try {
        //   if (input.length > 0) {
        //     this.searchComponent.searchControl.reset();
        //     this.searchComponent.searchControl.disable();
        //   } else {
        //     this.searchComponent.searchControl.enable();
        //   }
        // } catch {
        //   console.log('input undefined');
        // }
      });

      this.toCorpComponent.toCorpControl.valueChanges.subscribe(input => {
        console.log('to corp input changes' + input);
        try {
          if (input.length > 0) {
            this.fromCorpComponent.fromCorpControl.setValidators([
              Validators.pattern('[a-zA-Z0-9]*'),
              Validators.maxLength(5),
              Validators.minLength(0),
            ]);
            this.fromCorpComponent.fromCorpControl.updateValueAndValidity();

            // this.searchComponent.searchControl.reset();
            // this.searchComponent.searchControl.disable();
          } else {
            // this.searchComponent.searchControl.enable();
          }
        } catch {
          console.log('input undefined');
        }
      });

      // reset session storage after initialization
      sessionStorage.setItem('templateId', 'null');
      sessionStorage.setItem('templateNm', 'null');
      // session timer startup for detecting session
      this.sessionTimer();
    });
  }

  // stop session timers once the modal is removed
  ngOnDestroy(): void {
    this.sessionTimerService.stopTimers();
  }

  // session timer method for tracking session using mouse movement
  @HostListener('mousemove')
  sessionTimer() {
    this.sessionTimerService.checkSessionStatus();
  }

  // Service calls
  serviceGetContextsByStatus(listOfCorps, updateRuleRequest, addedCorps, removeCorps) {
    this.efsApiService.getContextsByStatus(listOfCorps, this.ruleClassId).subscribe((data: any) => {
      console.log(JSON.stringify(data));
      this.contexts = data;
      const filteredContexts = [];
      const corpList = [];

      for (const item of this.contexts) {
        if (item === null) {
          console.log('it was null context');
        } else {
          console.log(item.ruleClassId + ' ' + this.ruleClassId);
          if (item.ruleClassId.toString() === this.ruleClassId.toString()) {
            console.log('not null');
            filteredContexts.push(item);
            corpList.push(item.corpCd);
          }
        }
      }
      console.log(JSON.stringify(filteredContexts));
      // user decision tree on whether they want to proceed with save
      if (filteredContexts.length > 0) {
        this.popupWarning(true, '', 'The following corps are associated with other rules and will be moved to this rule: \n\n' + corpList + '\n\n continue?');

        this.popupDialogRef.afterClosed().subscribe(result => {
          if (result === true) {
            console.log('continue');
            // for each context, determine whether it is open or approved, and reject or retire appropriately, and update
            // previous rule context id as appropriate on approved contexts
            if (this.data.templateData.status === 'Open' || this.data.templateData.status === 'New') {
              for (const context of filteredContexts) {
                // update rule request for pre-disassociations/deletes for already approved rule contexts
                const updateContextsRequest = { // FOR DOING DISASSOCAITONS PRIOR TO ASSOCIATIONS
                  listCorpRuleContextAdd: [],
                  contexts_reject: [],
                  contexts_retire: []
                };

                console.log(JSON.stringify(this.updateRuleRequest));
                console.log('current context is' + JSON.stringify(context));

                if (context.fromDt !== null && context.fromDt !== undefined) { // approved
                  console.log('context is approved type 1');
                  // set the previous_rule_context_id to new association
                  const contextToBeAssoc = this.updateRuleRequest.listCorpRuleContextAdd.find(
                    x => x.blnktSlsOrderCd === context.corpCd);

                  console.log('contextToBeAssoc ' + JSON.stringify(contextToBeAssoc));

                  contextToBeAssoc.previousRuleContextId = context.ruleContextId;
                  console.log(JSON.stringify(contextToBeAssoc));
                } else { // open/new
                  console.log('context is open/new type 1');
                  updateContextsRequest.contexts_reject.push(context.ruleContextId);
                }
                console.log('updateContextRequest ' + JSON.stringify(updateContextsRequest));
                // finally, save the results and lock the form
                this.serviceReAssignCorps(updateContextsRequest, context.ruleId);
              }


            } else if (this.data.templateData.status === 'Approved') {
              for (const context of filteredContexts) {
                // update rule request for pre-disassociations/deletes for already approved rule contexts
                const updateContextsRequest = { // FOR DOING DISASSOCAITONS PRIOR TO ASSOCIATIONS
                  listCorpRuleContextAdd: [],
                  contexts_reject: [],
                  contexts_retire: []
                };

                console.log(JSON.stringify(this.updateRuleRequest));
                console.log('current context is' + JSON.stringify(context));

                if (context.fromDt !== null && context.fromDt !== undefined) { // approved
                  console.log('context is approved type 2');
                  // retire this associations
                  updateContextsRequest.contexts_retire.push(context.ruleContextId);
                  // set the previous_rule_context_id to new association
                  const contextToBeAssoc = this.updateRuleRequest.listCorpRuleContextAdd.find(
                    x => x.blnktSlsOrderCd === context.corpCd);

                  console.log('contextToBeAssoc ' + JSON.stringify(contextToBeAssoc));

                  contextToBeAssoc.previousRuleContextId = context.ruleContextId;
                  console.log(JSON.stringify(contextToBeAssoc));

                } else { // open/new
                  console.log('context is open/new type 2');
                  updateContextsRequest.contexts_reject.push(context.ruleContextId);
                }
                // finally, save the results and lock the form
                this.serviceReAssignCorps(updateContextsRequest, context.ruleId);
              }

            }

            console.log('final update ' + JSON.stringify(this.updateRuleRequest));
            // finally, save the results and lock the form
            this.serviceSaveRuleContexts(this.updateRuleRequest, addedCorps, removeCorps);
          } else {
            this.toggleSaveButton = false;
            console.log('NO');
          }
        });

      } else { // none are associated, proceed as normal
        console.log('no assoc contexts, save');
        // finally, save the results and lock the form
        this.serviceSaveRuleContexts(this.updateRuleRequest, addedCorps, removeCorps);

      }

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
    });

  }

  serviceGetRuleCorps(fromCorp, toCorp, facilityId, clientId) {
    // do not allow blank
    if (fromCorp === '') {
      fromCorp = null;
    }
    if (toCorp === '') {
      toCorp = null;
    }
    if (clientId === '') {
      clientId = null;
    }
    // set the client id if client id is not present
    if (!this.checkValue(clientId)) {
      const clientIdCheck = this.corpList.find(x => x.blnktSlsOrderCd === fromCorp);
      clientId = clientIdCheck.clientId;
    }

    this.efsApiService.getRuleCorps(fromCorp, toCorp, facilityId, clientId, this.data.templateData.ruleId).subscribe((data: any) => {
      const corpList = [];
      console.log('raw data getRuleCorps ' + JSON.stringify(data));
      for (const item of data) {
        try {
          corpList.push({
            blnktSlsOrderCd: item.ruleDetailList[0].blnktSlsOrderCd,
            clientNm: item.ruleDetailList[0].clientNm
          });
        } catch {
          console.log('corp was filtered/ non existent');
        }
      }

      console.log('raw data corpList ' + JSON.stringify(corpList));

      this.availCorpsTable = corpList;
      // filter duplicates
      this.availCorpsTable = this.availCorpsTable.filter((test, index, array) =>
        index === array.findIndex((findTest) => findTest.blnktSlsOrderCd === test.blnktSlsOrderCd)
      );
      this.availCorpsTable = this.availCorpsTable.sort(this.sortByProperty('blnktSlsOrderCd'));
      this.reusableTable1.dataSource.data = this.availCorpsTable;

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }


  serviceSaveRuleContexts(ruleUpdateBody, addedCorps, removeCorps) {
    this.efsApiService.updateRule(this.data.templateData.ruleId, ruleUpdateBody, this.data.ruleClassName).subscribe((data: any) => {
      console.log(data);
      if (this.data.templateData.status === 'Open' || this.data.templateData.status === 'New') {
        this.popupWarning(false, 'Success', 'The Associated Corps list has been updated. ' +
          'These changes will become effective after this open rule edition is approved' +
          '\n' + 'Corps Added: ' + addedCorps + '\n\n' + 'Corps Removed: ' + removeCorps);
      } else if (this.data.templateData.status === 'Approved') {
        this.popupWarning(false, 'Success', 'The Associated Corps list has been updated and will take effect immediately.' +
          '\n\n' + 'Corps Added: ' + addedCorps + '\n\n' + 'Corps Removed: ' + removeCorps);
      }
      // this.popupWarning(false, 'Success', 'Corps have been associated/disassociated ' + '\n\n'
      //   + 'associated: ' + addedCorps + '\n\n' + ' Disassociated: ' + removeCorps);
      this.popupDialogRef.afterClosed().subscribe(result => {
        console.log(result);
        // close the popup if in popup mode
        this.cancelButton();
      });
      this.dataSharingService.shareData('modified');
    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }

  serviceReAssignCorps(ruleUpdateBody, ruleId) {
    this.efsApiService.updateRule(ruleId, ruleUpdateBody, this.data.ruleClassName).subscribe((data: any) => {
      console.log(data);

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }


  serviceGetRuleContextByRuleId() {
    this.efsApiService.getRuleContextsByRuleId(this.data.templateData.ruleId, true).subscribe((data: any) => {
      this.hideLoader = true;
      this.hidePage = false;
      console.log('rule contexts' + JSON.stringify(data));
      this.ruleContexts = data;
      // copy data
      this.assocCorpsTable = JSON.parse(JSON.stringify(data));
      // load left hand side table, convert facility to codes
      // for (const item of this.ruleContexts) {
      //   console.log('count is this taking long?');
      //   const corpRow = {
      //     blnktSlsOrderCd: '',
      //     clientId: 0,
      //     facilityCd: ''
      //   };
      //   corpRow.blnktSlsOrderCd = item.blnktSlsOrderCd;
      //   corpRow.clientId = item.contexts.clientId;
      //   corpRow.facilityCd = item.contexts.facilityId;
      //   if (corpRow.facilityCd === undefined) {
      //     corpRow.facilityCd = 'All Facilities';
      //   }
      //   // convert facility id to code
      //   for (const facility of this.facilitiesToHold) {
      //     console.log(facility + ' ' + corpRow.facilityCd);
      //     if (facility.facilityId === corpRow.facilityCd) {
      //       corpRow.facilityCd = facility.facilityCd;
      //       break;
      //     }
      //   }
      //   this.assocCorpsTable.push(corpRow);
      // }

      // sort
      this.assocCorpsTable = this.assocCorpsTable.sort(this.sortByProperty('blnktSlsOrderCd'));

      this.reusableTable0.dataSource.data = this.assocCorpsTable;
      this.ref.detectChanges();

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.hideLoader = true;
      this.hidePage = false;
    });

  }

  serviceGetAllDistinctCorps(userInput, clientId, fromOrTo) {
    // if (clientId !== null && clientId !== 'null' && clientId !== '') {
    let tempClientId = clientId;
    if (clientId === '' || clientId === undefined || clientId === 'undefined') {
      tempClientId = 'null';
    }
    console.log(this.fromCorpComponent.fromCorpControl.status);
    console.log(this.toCorpComponent.toCorpControl.status);
    if (userInput !== '' && this.fromCorpComponent.fromCorpControl.status === 'VALID' &&
      this.toCorpComponent.toCorpControl.status === 'VALID') { // activating on empty user input, causing error
      this.efsApiService.getAllDistinctCorps(
        userInput,
        tempClientId,
        'null').subscribe((data: any) => {
          if (fromOrTo === true) {
            this.fromEventSubject.next(data.slice(0, 101)); // only first 100
          } else {
            this.toEventSubject.next(data.slice(0, 101)); // only first 100
          }
          this.availCorpsTable = data;
          this.reusableTable1.dataSource.data = this.availCorpsTable;
        }, error => {
          this.apiErrorHandlingService.errorStatusHandler(error);
        });
    }
  }

  serviceGetTemplateCorps() {
    if (this.data.templateData.templateId !== null
      && this.data.templateData.templateId !== 'null'
      && this.data.templateData.templateId !== '') {

      console.log('in common list corps, what am I passing to service? ' + this.data.moduleName + ' ' + this.data.templateData.templateId);

      // calls the efs api service for this module, in this case for getting all the template corps of this module
      this.efsApiService.callServiceTemplateCorps(this.data.moduleName, this.data.templateData.templateId).subscribe((data: any) => {
        console.log(data);
        if (data !== null) {
          console.log('TEMPLATE CORPS ' + JSON.stringify(data.bsoTemplateDetailList));
          this.bsoTemplateDetailList = data.bsoTemplateDetailList;
          // make a copy
          this.bsoTemplateDetailListCopy = JSON.parse(JSON.stringify(data.bsoTemplateDetailList));
          // create a list of assigned facilities to check against; the remove list cannot have more than what is in this list
          for (const item of this.bsoTemplateDetailListCopy) {
            const facilityIdAndCorp = { facilityId: '', blnktSlsOrderCd: '' };
            facilityIdAndCorp.facilityId = item.facilityId;
            facilityIdAndCorp.blnktSlsOrderCd = item.blnktSlsOrderCd;
            this.assignedFacilitiesToCorpsList.push(facilityIdAndCorp);
          }
          console.log('assigned facility and corp ' + JSON.stringify(this.assignedFacilitiesToCorpsList));

          for (const item of this.bsoTemplateDetailList) { // append the name of the template this corp is associated to
            console.log(JSON.stringify(item));
            item.templateDesc = this.templateDesc;
            // append the facility code to every item based on facility ID
            const facilityObj = this.facilitiesToHold.find(x => x.facilityId === item.facilityId);
            item.facilityCd = facilityObj.facilityCd;
            // console.log('ITEM WITH FACILITY CD ' + JSON.stringify(item));
          }

          this.assocCorpsTable = data.bsoTemplateDetailList;
          this.reusableTable0.dataSource.data = this.bsoTemplateDetailList;

          // get all unique bso ids to identify all pre-associated corps, also get all associated corps for use in searchJson
          for (const item of this.bsoTemplateDetailList) {
            this.bsoCodeAssocIds.push(item.blnktSlsOrderId);
            this.searchJson.associatedCorps.push(item.blnktSlsOrderCd);
          }
          console.log(this.bsoCodeAssocIds);
          console.log(JSON.stringify(this.searchJson));
        }
      }, error => {
        this.apiErrorHandlingService.errorStatusHandler(error);
      });
      // this.efsApiService.getPreholdTemplateCorps(this.data.templateData.templateId).subscribe((data: any) => {
      //   console.log(data);
      //   if (data !== null) {
      //     console.log('TEMPLATE CORPS ' + JSON.stringify(data.bsoTemplateDetailList));
      //     this.bsoTemplateDetailList = data.bsoTemplateDetailList;
      //     // make a copy
      //     this.bsoTemplateDetailListCopy = JSON.parse(JSON.stringify(data.bsoTemplateDetailList));
      //     // create a list of assigned facilities to check against; the remove list cannot have more than what is in this list
      //     for (const item of this.bsoTemplateDetailListCopy) {
      //       const facilityIdAndCorp = { facilityId: '', blnktSlsOrderCd: '' };
      //       facilityIdAndCorp.facilityId = item.facilityId;
      //       facilityIdAndCorp.blnktSlsOrderCd = item.blnktSlsOrderCd;
      //       this.assignedFacilitiesToCorpsList.push(facilityIdAndCorp);
      //     }
      //     console.log('assigned facility and corp ' + JSON.stringify(this.assignedFacilitiesToCorpsList));

      //     for (const item of this.bsoTemplateDetailList) { // append the name of the template this corp is associated to
      //       item.templateDesc = this.templateDesc;
      //       // append the facility code to every item based on facility ID
      //       const facilityObj = this.facilitiesToHold.find(x => x.facilityId === item.facilityId);
      //       item.facilityCd = facilityObj.facilityCd;
      //       // console.log('ITEM WITH FACILITY CD ' + JSON.stringify(item));
      //     }

      //     this.assocCorpsTable = data.bsoTemplateDetailList;
      //     this.reusableTable0.dataSource.data = this.bsoTemplateDetailList;

      //     // get all unique bso ids to identify all pre-associated corps, also get all associated corps for use in searchJson
      //     for (const item of this.bsoTemplateDetailList) {
      //       this.bsoCodeAssocIds.push(item.blnktSlsOrderId);
      //       this.searchJson.associatedCorps.push(item.blnktSlsOrderCd);
      //     }
      //     console.log(this.bsoCodeAssocIds);
      //     console.log(JSON.stringify(this.searchJson));
      //   }
      // }, error => {
      //   if (error.status === 401) {
      //     if (environment.envName !== 'dev') {
      //       alert('Session is expired and you will be returned to customer center');
      //       sessionStorage.clear();
      //       document.location.href = this.efsApiService.redirectUrl;
      //     }
      //   }
      // });
    } else {
      console.log('No Template Id provided');
    }
  }

  serviceGetClientsByName(userInput) {
    if (userInput.length >= 3) { // get the initial client list
      this.efsApiService.getAllClientsByName(userInput).subscribe((clients: any) => {
        this.clients = clients;
        if (this.clients.length === 0) {
          console.log('empty clients list');
          return;
        }
        this.clientEventSubject.next(clients);
        // console.log(this.clients.length);
      }, error => {
        this.apiErrorHandlingService.errorStatusHandler(error);
      });
    } else { // search on cached list
      const clientList = [];
      for (const item of this.clients) {
        // console.log(JSON.stringify(item.clientNm.toLowerCase().slice(userInput.length)));
        if (item.clientNm.toLowerCase() === userInput.toLowerCase() + item.clientNm.toLowerCase().slice(userInput.length)) {
          clientList.push(item);
        }
      }
      console.log('filtered client list is ' + JSON.stringify(clientList));
      this.clientEventSubject.next(clientList);
    }
  }

  serviceGetCorps(userInput, clientId, fromOrTo) {
    // if (clientId !== null && clientId !== 'null' && clientId !== '') {
    let tempClientId = clientId;
    if (clientId === '' || clientId === undefined || clientId === 'undefined') {
      tempClientId = 'null';
    }
    console.log(this.fromCorpComponent.fromCorpControl.status);
    console.log(this.toCorpComponent.toCorpControl.status);
    if (userInput !== '' && this.fromCorpComponent.fromCorpControl.status === 'VALID' &&
      this.toCorpComponent.toCorpControl.status === 'VALID') { // activating on empty user input, causing error
      this.efsApiService.getAllDistinctCorps(
        userInput,
        tempClientId,
        'null').subscribe((data: any) => {
          let corpList = [];
          corpList = data;
          this.corpList = data;
          // filter data caused by corps in multiple facilities
          const uniqueArray =
            corpList.filter((object, index) =>
              index === corpList.findIndex(obj => JSON.stringify(obj.blnktSlsOrderCd) === JSON.stringify(object.blnktSlsOrderCd)));
          console.log('filter list ' + JSON.stringify(data));
          if (fromOrTo === true) {
            this.fromEventSubject.next(uniqueArray.slice(0, 101)); // only first 100
          } else {
            this.toEventSubject.next(uniqueArray.slice(0, 101)); // only first 100
          }
        }, error => {
          this.apiErrorHandlingService.errorStatusHandler(error);
        });
    }
  }

  serviceGetTemplateAvailableCorps() {
    if (this.toCorp === '') { // null or empty string is equal to from corp
      this.toCorp = 'null';
    }
    console.log('what is search json ' + this.searchJson);
    // this.searchJson = {
    //   templateId: '14',
    //   associatedCorps: ['54300'],
    //   targetClientId: null,
    //   disAssociatedFromCorpCd: 'B5437',
    //   disAssociatedToCorpCd: 'B5437'
    // };
    // final check for valid search criteria, if all is null or empty, reject
    if (this.searchJson.disAssociatedFromCorpCd === '' || this.searchJson.disAssociatedFromCorpCd === 'null' &&
      this.searchJson.disAssociatedToCorpCd === '' || this.searchJson.disAssociatedToCorpCd === 'null' &&
      this.searchJson.targetClientId === '' || this.searchJson.targetClientId === 'null') {
      console.log('no valid search criteria, reject');
      // this.popupWarning(false, 'Alert', '');
      return;
    }
    // do a seperate check to ensure template id exists
    if (this.searchJson.templateId === '' || this.searchJson.templateId === undefined) {
      this.popupWarning(false, 'Alert', 'Template ID is missing');
      return;
    }


    this.efsApiService.callServiceTemplateAvailableCorps('modulePT', this.searchJson).subscribe((data: any) => {
      this.availCorpsTable = [];
      console.log('Template Desc ' + JSON.stringify(data));
      // flatten data for table
      for (const item of data) {
        this.genericizeTemplateName(item); // incoming data field is not generic, make it so
        for (const detailList of item.bsoTemplateDetailList) {
          detailList.templateId = item.templateId;
          detailList.templateDesc = item.templateDesc;
          // add the facility id to the row item
          console.log('before lookup ' + detailList.facilityId);
          detailList.facilityId = this.facilityIdLookup(detailList.facilityCd);
          console.log('after lookup ' + detailList.facilityId);
          if (detailList.templateDesc === undefined) { detailList.templateDesc = ''; } // dont show undefined in table
          this.availCorpsTable.push(detailList);
        }
      }
      // goal is to filter the corps by available facility, remove any corps that are not part of the dropdown list
      // console.log(JSON.stringify(this.availCorpsTable));
      // console.log(JSON.stringify(this.facilitiesToHold));
      this.availCorpsTable = this.availCorpsTable.filter(item => {
        try {
          return this.facilityCds.includes(item.facilityCd);
        } catch { // ie does not support this, so try this instead
          if (this.facilityCds.indexOf(item.facilityCd) !== -1) {
            return true;
          } else { return false; }
        }
      });
      // console.log('post filter ' + JSON.stringify(this.availCorpsTable));
      // console.log('TEMPLATE DESC ' + JSON.stringify(this.availCorpsTable));
      // this.availCorpsTable = this.buildTemplateName(this.availCorpsTable);
      this.reusableTable1.dataSource.data = this.availCorpsTable;
    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
    });

    // this.efsApiService.getPreholdTemplateAvailableCorps(this.searchJson).subscribe((data: any) => {
    //   this.availCorpsTable = [];
    //   console.log('Template Desc ' + JSON.stringify(data));
    //   // flatten data for table
    //   for (const item of data) {
    //     for (const detailList of item.bsoTemplateDetailList) {
    //       detailList.templateId = item.templateId;
    //       detailList.templateDesc = item.templateDesc;
    //       // add the facility id to the row item
    //       console.log('before lookup ' + detailList.facilityId);
    //       detailList.facilityId = this.facilityIdLookup(detailList.facilityCd);
    //       console.log('after lookup ' + detailList.facilityId);
    //       if (detailList.templateDesc === undefined) { detailList.templateDesc = ''; } // dont show undefined in table
    //       this.availCorpsTable.push(detailList);
    //     }
    //   }


    //   // console.log('TEMPLATE DESC ' + JSON.stringify(this.availCorpsTable));
    //   // this.availCorpsTable = this.buildTemplateName(this.availCorpsTable);
    //   this.reusableTable1.dataSource.data = this.availCorpsTable;
    // }, error => {
    //   if (error.status === 401) {
    //     if (environment.envName !== 'dev') {
    //       alert('Session is expired and you will be returned to customer center');
    //       sessionStorage.clear();
    //       document.location.href = this.efsApiService.redirectUrl;
    //     }
    //   }
    //   if (error.status === 404) {
    //     alert('404 Not Found, is there a clientID?');
    //   }
    // });
  }

  serviceUpdateTemplate(corpsAdded) {
    this.efsApiService.callServiceUpdateTemplate(this.data.moduleName, corpsAdded).subscribe((data: any) => {
      console.log(data);
      this.popupWarning(false, 'Success', 'The Associated Corps list has been updated.');
      this.popupDialogRef.afterClosed().subscribe(result => {
        console.log(result);
        // close the popup if in popup mode
        this.cancelButton();
      });
      this.dataSharingService.shareData('modified');
    }, error => {
      this.saveStatus = false;
      if (error.status === 400 || error.status === 404 || error.status === 500 || error.status === 502) {
        // alert('Bad Request ' + error.error);
        this.popupWarning(false, 'Error', error.error);
      } else {
        this.apiErrorHandlingService.errorStatusHandler(error);
      }
    });


    // this.efsApiService.updatePreholdTemplate(corpsAdded).subscribe((data: any) => {
    //   console.log(data);
    //   this.dataSharingService.shareData('modified');
    //   // close the popup if in popup mode
    //   if (this.showXButton) {
    //     this.cancelButton();
    //   }
    // }, error => {
    //   this.saveStatus = false;
    //   if (error.status === 401) {
    //     if (environment.envName !== 'dev') {
    //       alert('Session is expired and you will be returned to customer center');
    //       sessionStorage.clear();
    //       document.location.href = this.efsApiService.redirectUrl;
    //     }
    //   } else if (error.status === 400) {
    //     alert('Bad Request ' + JSON.stringify(error));
    //   }
    // });
  }

  /**
   * this service will get all facilities based on which module is calling it.
   * for example, plan template module will call getFacilitiesPT.
   */
  serviceGetFacilities() {
    this.efsApiService.getRuleFacilities().subscribe((data: any) => {
      console.log(JSON.stringify(data));
      this.facilitiesToHold = data;
      // place the facility codes in a seperate list
      for (const item of this.facilitiesToHold) {
        this.facilityCds.push(item.facilityCd);
      }
      this.facilityControl.setValue(this.allSelectedValue); // set default value

      this.serviceGetRuleContextByRuleId();
    },
      error => {
        this.apiErrorHandlingService.errorStatusHandler(error);
      });

    // this.efsApiService.getFacilities().subscribe((data: any) => {
    //   console.log(JSON.stringify(data));
    //   this.facilitiesToHold = data;
    //   this.facilityControl.setValue(this.allSelectedValue); // set default value
    //   this.serviceGetTemplateCorps();
    // },
    //   error => {
    //     this.apiErrorHandlingService.errorStatusHandler(error);
    //   });
  }


  // end of service calls

  rightFilterControl() {
    this.rightSideAvailFilterControl.valueChanges.subscribe(input => {
      console.log(input);
      const filteredAssocCorps = [];
      for (const item of this.availCorpsTable) { // match and return look ahead
        if (input.toUpperCase() + item.blnktSlsOrderCd.toUpperCase().slice(input.length) === item.blnktSlsOrderCd) {
          filteredAssocCorps.push(item);
        }
      }
      if (filteredAssocCorps.length <= 0) {
        this.reusableTable1.dataSource.data = this.availCorpsTable; // display ALL
      } else {
        this.reusableTable1.dataSource.data = filteredAssocCorps; // display filtered
      }
    });

  }

  filterAssocCorps() {
    this.assocFilterControl.valueChanges.subscribe(input => {
      console.log(input);
      const filteredAssocCorps = [];
      // this.reusableTable0.dataSource.data = this.assocCorpsTable; // update left hand table
      // userInput.toLowerCase() + item.clientNm.toLowerCase().slice(userInput.length)
      for (const item of this.assocCorpsTable) { // match and return look ahead
        if (input.toUpperCase() + item.blnktSlsOrderCd.toUpperCase().slice(input.length) === item.blnktSlsOrderCd) {
          filteredAssocCorps.push(item);
        }
      }
      if (filteredAssocCorps.length <= 0) {
        this.reusableTable0.dataSource.data = this.assocCorpsTable; // display ALL
      } else {
        this.reusableTable0.dataSource.data = filteredAssocCorps; // display filtered
      }
    });
  }

  genericizeTemplateName(item) { // genericize incoming template names that belong to each module
    if (this.data.moduleName === 'modulePH') {
      // prehold non generics
      item.templateDesc = item.preholdTemplateDesc;
    } else if (this.data.moduleName === 'moduleDM') {
      // delayed mail non generics

    } else if (this.data.moduleName === 'modulePS') {
      // production setup non-generics

    } else if (this.data.moduleName === 'modulePT') {
      // plan template non-generics
      item.templateDesc = item.planTemplateDesc;
    } else if (this.data.moduleName === 'modulePM') {
      // prod method group non-generics
      item.templateDesc = item.prodmethodgroupTemplateDesc;
    } else if (this.data.moduleName === 'modulePA') {
      // prod method group non-generics

    }
  }

  buildTemplateName(availCorpsTable) { // append template name to top level of array item in order to display in table
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < availCorpsTable.length; i++) {
      // console.log(JSON.stringify(availCorpsTable[i]));
      availCorpsTable[i].TemplateName = '';
      // tslint:disable-next-line:prefer-for-of
      for (let j = 0; j < availCorpsTable[i].templateList.length; j++) {
        // console.log(availCorpsTable[i].templateList.length);
        if (availCorpsTable[i].templateList.length > 0) {
          availCorpsTable[i].TemplateName = availCorpsTable[i].templateList[j].templateDesc;
        }
      }
    }
    console.log('RETURN IS ' + JSON.stringify(availCorpsTable));
    return availCorpsTable;
  }

  compareAlphaNumericCorps(critFromCorp, critToCorp) {
    const fromCorp = critFromCorp;
    const toCorp = critToCorp;

    for (let i = 0; i < fromCorp.length; i++) {
      for (let j = i; j <= i; j++) {
        if (toCorp.charCodeAt(j) < fromCorp.charCodeAt(i)) {
          return false;
        } else if (toCorp.charCodeAt(j) > fromCorp.charCodeAt(i)) {
          return true;
        }
      }
    }
    return true;
  }

  setValues() {
    this.clientId = sessionStorage.getItem('clientId');
    this.clientName = sessionStorage.getItem('clientNm');
    this.clientNameDisp = sessionStorage.getItem('clientNm');
    if (this.clientNameDisp === 'null') {
      this.clientNameDisp = '';
    }
    this.ruleName = this.data.templateData.ruleNm;
    this.ruleStatus = this.data.templateData.status;
    this.ruleDescription = this.data.templateData.ruleDesc;
    // this.statesToHold = this.data.templateData.statesToHold;

    // Set search criteria
    this.searchJson.templateId = 'null';
    this.searchJson.facilityId = 'null';

    // begin building the body that will be sent to the api
    this.updateListCorps.templateId = this.data.templateData.templateId;
    this.updateListCorps.description = this.data.templateData.templateDesc;
  }

  /**
   * match selected row to item in right side table list, then remove it and move it to next table
   */
  assocCorps() {
    console.log(this.facilityControl.value);
    const selectedValue = JSON.parse(JSON.stringify(this.table1rowData));

    // this.serviceGetContextsByStatus(this.data.templateData.status, selectedValue[0].blnktSlsOrderCd, null);

    if (this.toggleAsscButton === true) { return; }
    const availCorpItems = []; // save a list of items to remove from the update body
    // for every selected row item, match with table row, delete from table row and add to left hand table

    try {
      for (const selectedItem of this.table1rowData) {
        for (let i = this.availCorpsTable.length - 1; i >= 0; i--) {
          if (this.availCorpsTable[i] === selectedItem) {
            this.availCorpsTable.splice(i, 1);
          }
        }
      }
    } catch {
      console.warn('No row items have been selected');
      return;
    }


    // if bso code appears in bso details list, dont add corps added list; else add to corps added list
    for (const item of this.table1rowData) {
      let isMatch = true;
      try {
        for (const copyItem of this.bsoTemplateDetailListCopy) {
          if (item.blnktSlsOrderCd === copyItem.blnktSlsOrderCd && item.facilityId === copyItem.facilityId) {
            isMatch = true;
            break;
          } else {
            isMatch = false;
          }
        }
      } catch {
        console.log('copy list is empty');
        isMatch = false;
      }
      if (!isMatch) { // if it doesnt exist in the copy list, add to corps added list
        this.updateListCorps.corpsAdded.push(item.blnktSlsOrderCd);
        // console.log('What is being pushed into faclities added? ' + JSON.stringify(item.facilityId));
        this.updateListCorps.facilitiesAdded.push(item.facilityId); // add the facility id as well
      }
    }
    // from the available corps row items list, create a list of actual corps removed
    for (const item of this.table1rowData) {
      console.log('AVAIL CORPS ROW ITEMS ' + JSON.stringify(item));
      try { // catch error when there are no associated corps
        for (const copyItem of this.bsoTemplateDetailListCopy) {
          if (item.blnktSlsOrderCd === copyItem.blnktSlsOrderCd && item.facilityId === copyItem.facilityId) {
            availCorpItems.push(item); // corp being disassociated is currently associated, no net change
          }
        }
      } catch {
        console.log('Currently there are no associated corps');
      }

    }
    // remove from corpsRemoved if the bso code appears in copy list; only if no net change
    try {
      console.log(JSON.stringify(availCorpItems));
      for (const item of availCorpItems) {
        for (let i = this.updateListCorps.corpsRemoved.length - 1; i >= 0; i--) {
          console.log('REMOVE CORPS REMOVED ' + item.blnktSlsOrderCd + ' ' + this.updateListCorps.corpsRemoved[i]);
          if (item.blnktSlsOrderCd === this.updateListCorps.corpsRemoved[i]) {
            this.updateListCorps.corpsRemoved.splice(i, 1);
            break;
          }
        }
      }
    } catch {
      console.log('bsoTemplateDetailsListCopy is empty');
    }

    try {
      // remove from facilities removed list if facility id apperas in copy list
      for (const item of availCorpItems) {
        for (let i = this.updateListCorps.facilitiesRemoved.length - 1; i >= 0; i--) {
          console.log('REMOVE CORPS REMOVED ' + item.facilityId + ' ' + this.updateListCorps.facilitiesRemoved[i]);
          if (item.facilityId === this.updateListCorps.facilitiesRemoved[i]) {
            this.updateListCorps.facilitiesRemoved.splice(i, 1);
            break;
          }
        }
      }
    } catch {
      console.log('bsoTemplateDetailsListCopy is empty');
    }

    // add all selected items
    // this.serviceGetContextsByStatus(this.data.templateData.status, selectedValue[0].blnktSlsOrderCd, null, selectedValue);
    for (const item of selectedValue) {
      this.addButtonLogic(item, selectedValue);
    }

    this.reusableTable0.dataSource.data = this.assocCorpsTable; // update left hand table

    // this.reusableTable0.dataSource.data = this.assocCorpsTable; // update left hand table
    this.reusableTable1.dataSource.data = this.availCorpsTable; //  update right hand table
    // this.table1rowData = []; // reset the selected data
    // reset checkmarks on lefthand table
    this.reusableTable1.selection.clear();

    this.toggleSaveButton = false;

  }

  addButtonLogic(item, selectedValue) {
    // add the facility to the row data that is to be added to the left side
    const facilityItem = this.facilityControl.value;
    console.log(facilityItem);
    item.facilityId = facilityItem.facilityId;
    item.facilityCd = facilityItem.facilityCd;
    item.facilityNm = facilityItem.facilityNm;
    if (item.facilityId === undefined) {
      item.facilityCd = 'All Facilities';
    }

    // push every new row to the left hand table
    console.log('what is tablerow data ' + JSON.stringify(item) + ' ' + JSON.stringify(this.assocCorpsTable));
    if (this.assocCorpsTable.length === 0) {
      console.log('left hand side empty');
      this.assocCorpsTable.push(item);
    } else {
      const leftHandMatch = this.assocCorpsTable.find(x => (x.blnktSlsOrderCd === item.blnktSlsOrderCd));
      console.log('left hand match ' + JSON.stringify(leftHandMatch));

      if (leftHandMatch === undefined) {
        this.assocCorpsTable.push(item);
      } else {
        console.warn('cannot add same corp/facility combination');
      }

    }
  }

  /**
   * match selected row to item in left side table list, then remove it and move it to next table
   */
  removeCorps() {
    if (this.toggleDiscButton === true) { return; } // disabled
    try {
      // for every selected row item, match with table row, delete from table row and add to right hand table
      for (const selectedItem of this.table0rowData) {
        // add to removed list if in copy list, must match corp number as well
        for (const facilityAndCorp of this.assignedFacilitiesToCorpsList) {
          console.log('facility and corp ' + facilityAndCorp.facilityId + ' ' + facilityAndCorp.blnktSlsOrderCd);
          if (selectedItem.facilityId === facilityAndCorp.facilityId && selectedItem.blnktSlsOrderCd === facilityAndCorp.blnktSlsOrderCd) {
            this.updateListCorps.facilitiesRemoved.push(selectedItem.facilityId);
          }
        }
        for (let i = this.assocCorpsTable.length - 1; i >= 0; i--) {
          if (this.assocCorpsTable[i] === selectedItem) {
            this.assocCorpsTable.splice(i, 1);
          }
        }
      }

      console.log('WHAT IS IN TABLE0ROWDATA ' + JSON.stringify(this.table0rowData));
      console.log('WHAT IS IN BSOTEMPLATEDETAILLIST ' + JSON.stringify(this.bsoTemplateDetailListCopy));
      // add corp code to the remove list if it is in the bsoTemplateDetailList
      for (const item of this.table0rowData) {
        let isMatch = true;
        try {
          for (const copyItem of this.bsoTemplateDetailListCopy) {
            if (item.blnktSlsOrderCd === copyItem.blnktSlsOrderCd && item.facilityId === copyItem.facilityId) {
              isMatch = true;
              break;
            } else {
              isMatch = false;
            }
          }
        } catch {
          console.log('copy list is empty');
          isMatch = false;
        }
        if (isMatch) { // if it does exist in the copy list, add to corps removed list
          this.updateListCorps.corpsRemoved.push(item.blnktSlsOrderCd);
        }
      }
      // remove from corps added;
      try {
        for (const item of this.bsoTemplateDetailListCopy) {
          for (let i = this.updateListCorps.corpsAdded.length - 1; i >= 0; i--) {
            console.log('REMOVE CORPS added ' + item.blnktSlsOrderCd + ' ' + this.updateListCorps.corpsAdded[i]);
            if (item.blnktSlsOrderCd === this.updateListCorps.corpsAdded[i]) {
              console.log('removed corp ' + item);
              this.updateListCorps.corpsAdded.splice(i, 1);
              break;
            } else {
              // this.updateListCorps.corpsAdded.splice(i, 1);
            }
          }
        }
        // this for loop is for tracking/removing corps that are free agents/not associated - cleanup
        console.log('bsoTemplateDetailListCopy is empty');
        for (const item of this.table0rowData) {
          for (let i = this.updateListCorps.corpsAdded.length - 1; i >= 0; i--) {
            console.log('REMOVE CORPS added ' + item.blnktSlsOrderCd + ' ' + this.updateListCorps.corpsAdded[i]);
            if (item.blnktSlsOrderCd === this.updateListCorps.corpsAdded[i]) {
              console.log('removed corp ' + item);
              this.updateListCorps.corpsAdded.splice(i, 1);
              break;
            } else {
              // this.updateListCorps.corpsAdded.splice(i, 1);
            }
          }
        }
      } catch { // remove from corps added
        console.log('bsoTemplateDetailListCopy is empty');
        for (const item of this.table0rowData) {
          for (let i = this.updateListCorps.corpsAdded.length - 1; i >= 0; i--) {
            console.log('REMOVE CORPS added ' + item.blnktSlsOrderCd + ' ' + this.updateListCorps.corpsAdded[i]);
            if (item.blnktSlsOrderCd === this.updateListCorps.corpsAdded[i]) {
              console.log('removed corp ' + item);
              this.updateListCorps.corpsAdded.splice(i, 1);
              break;
            } else {
              // this.updateListCorps.corpsAdded.splice(i, 1);
            }
          }
        }
      }
      // remove from facilities added list; add to facilities removed list if appears in copy list
      try {
        // for (const item of this.bsoTemplateDetailListCopy) {
        //   for (let i = this.updateListCorps.facilitiesAdded.length - 1; i >= 0; i--) {
        //     console.log('REMOVE CORPS added ' + item.facilityId + ' ' + this.updateListCorps.facilitiesAdded[i]);
        //     if (item.facilityId === this.updateListCorps.facilitiesAdded[i]) {
        //       this.updateListCorps.facilitiesAdded.splice(i, 1); // remove from list
        //     } else {
        //       // this.updateListCorps.facilitiesAdded.splice(i, 1); // remove from list
        //     }
        //   }
        // }
        // this for loop is for tracking/removing facil ids that are free agents/not associated - cleanup
        console.log('bsoTemplateDetailListCopy is empty');
        for (const item of this.table0rowData) {
          for (let i = this.updateListCorps.facilitiesAdded.length - 1; i >= 0; i--) {
            console.log('REMOVE CORPS added ' + item.facilityId + ' ' + this.updateListCorps.facilitiesAdded[i]);
            if (item.facilityId === this.updateListCorps.facilitiesAdded[i]) {
              for (const corpItem of this.assocCorpsTable) {
                console.log('corpitem is ' + corpItem.blnktSlsOrderCd);
                if (item.blnktSlsOrderCd === corpItem.blnktSlsOrderCd) {
                  // do nothing
                } else {
                  this.updateListCorps.facilitiesAdded.splice(i, 1); // remove from list
                  break;
                }
              }
              // this.updateListCorps.facilitiesRemoved.push(item.facilityId); // add to removed list if in copy list
            } else {
              // this.updateListCorps.facilitiesAdded.splice(i, 1); // remove from list
            }
          }
        }
      } catch { // remove from facilities added
        console.log('bsoTemplateDetailListCopy is empty');
        for (const item of this.table0rowData) {
          for (let i = this.updateListCorps.facilitiesAdded.length - 1; i >= 0; i--) {
            console.log('REMOVE CORPS added ' + item.facilityId + ' ' + this.updateListCorps.facilitiesAdded[i]);
            if (item.facilityId === this.updateListCorps.facilitiesAdded[i]) {
              this.updateListCorps.facilitiesAdded.splice(i, 1); // remove from list
              break;
              // this.updateListCorps.facilitiesRemoved.push(item.facilityId); // add to removed list if in copy list
            } else {
              // this.updateListCorps.facilitiesAdded.splice(i, 1); // remove from list
            }
          }
        }
      }

      console.log('CORPS REMOVED ' + JSON.stringify(this.updateListCorps));

      // push every new row to the left hand table
      for (const item of this.table0rowData) {
        this.availCorpsTable.push(item);
      }
      this.reusableTable0.dataSource.data = this.assocCorpsTable; // update left hand table
      this.reusableTable1.dataSource.data = this.availCorpsTable; //  update right hand table
      this.table0rowData = []; // reset the selected data
      // reset checkmarks on lefthand table
      this.reusableTable0.selection.clear();
      this.toggleSaveButton = false;
    } catch {
      console.warn('No rows have been selected for disassociation');
    }
  }

  clientSearchButton() {
    // do not allow search if client and from corp is empty
    if (this.searchComponent.searchControl.value === undefined && this.fromCorpComponent.fromCorpControl.value === '' ||
      this.searchComponent.searchControl.value === '' && this.fromCorpComponent.fromCorpControl.value === '') {
      // alert('Please provide a client or from corp number');
      this.popupWarning(false, 'Alert', 'A search must include a either a Client or From Corp or both.  If a From Corp is provided then a To Corp may also be provided.');
      return;
    }

    console.log(this.searchComponent.searchControl.value);
    console.log('what is toCorp? ' + this.toCorpComponent.toCorpControl.value);
    console.log('what is toCorp? ' + this.toCorp);
    try {
      if (this.searchComponent.searchControl.value.length <= 0) {
        // make sure the corps entered are valid; check only if client is empty
        console.log(this.searchComponent.searchControl.value.length);
        if (this.fromCorpComponent.fromCorpControl.status === 'INVALID' ||
          this.toCorpComponent.toCorpControl.status === 'INVALID') {
          this.openDialog('Invalid Corp Code', 'Please enter a valid corp');
          return;
        }
      } else {
        // if from corp is empty, since a client is provided set status to VALID
        if (this.fromCorpComponent.fromCorpControl.value.length <= 0) {
          console.log('did the validators change?');
          this.fromCorpComponent.fromCorpControl.setValidators([
            // Validators.required,
            Validators.pattern('[a-zA-Z0-9]*'),
            Validators.maxLength(5),
            Validators.minLength(0),
          ]);
          this.fromCorpComponent.fromCorpControl.updateValueAndValidity();
        }
        console.log(this.fromCorpComponent.fromCorpControl.status);
        console.log(this.toCorpComponent.toCorpControl.status);
      }
    } catch {
      console.log('did the validators change?');
      this.fromCorpComponent.fromCorpControl.setValidators([
        // Validators.required,
        Validators.pattern('[a-zA-Z0-9]*'),
        Validators.maxLength(5),
        Validators.minLength(0),
      ]);
      this.fromCorpComponent.fromCorpControl.updateValueAndValidity();
    }



    // make sure from corp is creater than to corp
    const fromCorpNo = this.fromCorpComponent.fromCorpControl.value;
    const toCorpNo = this.toCorpComponent.toCorpControl.value;
    console.log('FromCORP ' + fromCorpNo + 'toCORP ' + toCorpNo);
    console.log(this.compareAlphaNumericCorps(fromCorpNo, toCorpNo));
    if (!this.compareAlphaNumericCorps(fromCorpNo, toCorpNo)) {
      this.openDialog('Invalid Corp Code', 'To corp should be greater than from corp');
      return;
    }

    if (this.toCorpComponent.toCorpControl.value !== '' ||
      this.toCorpComponent.toCorpControl.value !== null &&
      this.searchComponent.searchControl.value === '') {
      console.log('IS THIS RUNNING?');
      this.fromCorpComponent.fromCorpControl.setValidators([
        Validators.pattern('[a-zA-Z0-9]*'),
        Validators.maxLength(5),
        Validators.minLength(0),
      ]);
      this.fromCorpComponent.fromCorpControl.updateValueAndValidity();
      this.fromCorpComponent.fromCorpControl.markAsTouched();
    }

    this.searchJson.targetClientId = this.searchClientId;
    // set the facilities selected for the search
    this.searchJson.facilityId = this.facilityIdSearchValue;
    console.log('VALUE?? ' + this.searchJson.facilityId);

    this.searchJson.disAssociatedFromCorpCd = this.fromCorp;
    if (this.toCorp === 'null' || this.toCorp === '' || this.toCorp === 'NULL') {
      this.searchJson.disAssociatedToCorpCd = this.searchJson.disAssociatedFromCorpCd;
    } else {
      this.searchJson.disAssociatedToCorpCd = this.toCorp;
    }
    // never give null for the range
    try {
      this.searchJson.disAssociatedFromCorpCd = this.fromCorpComponent.fromCorpControl.value.toUpperCase();
      this.searchJson.disAssociatedToCorpCd = this.toCorpComponent.toCorpControl.value.toUpperCase();
    } catch {
      this.searchJson.disAssociatedFromCorpCd = this.fromCorpComponent.fromCorpControl.value;
      this.searchJson.disAssociatedToCorpCd = this.toCorpComponent.toCorpControl.value;
    }


    console.log('FROM CORP AND TO CORP ARE ' + this.searchJson.disAssociatedFromCorpCd + this.searchJson.disAssociatedToCorpCd);

    if (this.searchJson.disAssociatedToCorpCd === '') { // set to equal to from if to is blank
      this.searchJson.disAssociatedToCorpCd = this.searchJson.disAssociatedFromCorpCd;
    }

    // either the range is null when client is provided, or client is null when range is provided
    if (this.searchJson.targetClientId === 'null' ||
      this.searchJson.targetClientId === 'NULL' ||
      this.searchJson.targetClientId === 'undefined'
    ) {
      console.log('IS CONDITION 1 FIRING?');
      this.searchJson.targetClientId = null;
    } else if (this.searchJson.targetClientId !== 'null'
      || this.searchJson.targetClientId !== null) {
      console.log('IS CONDITION 2 FIRING?');
      // this.searchJson.disAssociatedToCorpCd = 'null';
      // this.searchJson.disAssociatedFromCorpCd = 'null';
    }

    console.log(JSON.stringify(this.searchJson));

    this.serviceGetRuleCorps(
      this.searchJson.disAssociatedFromCorpCd,
      this.toCorp,
      null,
      this.searchJson.targetClientId
    );
    return;

    if (this.searchJson.targetClientId !== 'null' && this.searchJson.targetClientId !== null) { // cannot search if the client doesnt exist
      if (this.fromCorpComponent.fromCorpControl.status === 'VALID') {
        if (this.searchJson.disAssociatedFromCorpCd === '') {
          this.searchJson.disAssociatedFromCorpCd = 'null';
        }
        if (this.searchJson.disAssociatedToCorpCd === '') {
          this.searchJson.disAssociatedToCorpCd = 'null';
        }
        // this.serviceGetTemplateAvailableCorps();
        this.serviceGetAllDistinctCorps(null, this.searchJson.targetClientId, true);
      } else if (this.fromCorpComponent.fromCorpControl.disabled && this.fromCorpComponent.fromCorpControl.status === 'VALID') {
        // this.serviceGetTemplateAvailableCorps();
        this.serviceGetAllDistinctCorps(null, this.searchJson.targetClientId, true);
      } else {
        // alert('Please provide a corp range or Client name');
        this.popupWarning(false, 'Alert', 'Please provide a corp range or Client name');
      }
    } else if (this.searchJson.disAssociatedFromCorpCd !== 'null' &&
      this.searchJson.disAssociatedFromCorpCd !== null &&
      this.fromCorpComponent.fromCorpControl.status === 'VALID') {
      // this.serviceGetTemplateAvailableCorps();
      this.serviceGetAllDistinctCorps(null, this.searchJson.targetClientId, true);

    } else {
      console.log('no corps exist with that name');
      this.fromCorpComponent.fromCorpControl.markAsTouched();
      this.availCorpsTable = []; // clear the cache
      this.reusableTable1.dataSource.data = []; // reset the table bad info was entered
    }
  }

  /**
   * this method will do the final rule determination for sorting the left hand table into the various
   * lists that will be sent back to the backend. 3 rule system
   */
  submitProcessing() {
    console.log(JSON.stringify(this.updateListCorps));
    console.log(JSON.stringify(this.assignedFacilitiesToCorpsList));

    // make a copy of the left hand side table
    let associatedCorpsTableCopy = [];
    associatedCorpsTableCopy = JSON.parse(JSON.stringify(this.assocCorpsTable));
    console.log('what is the assoc corps table copy? ' + JSON.stringify(associatedCorpsTableCopy));
    // make a copy of the assigned corps list
    let assignedFacilitiesToCorpsListCopy = [];
    assignedFacilitiesToCorpsListCopy = JSON.parse(JSON.stringify(this.assignedFacilitiesToCorpsList));
    console.log('what is the assigned corps copy? ' + JSON.stringify(assignedFacilitiesToCorpsListCopy));

    this.updateListCorps.corpsRemoved = [];
    this.updateListCorps.corpsAdded = [];
    // this.updateListCorps.detailsUpdated = [];
    // this.updateListCorps.detailsRemoved = [];
    // this.updateListCorps.detailsAdded = [];
    this.updateListCorps.facilitiesAdded = [];
    this.updateListCorps.facilitiesRemoved = [];

    try {
      for (let i = associatedCorpsTableCopy.length - 1; i >= 0; i--) {
        console.log(associatedCorpsTableCopy[i].blnktSlsOrderCd);
        for (const assocItems of this.assignedFacilitiesToCorpsList) {
          console.log('why is it undefined? ' + associatedCorpsTableCopy[i].blnktSlsOrderCd + ' ' + assocItems.blnktSlsOrderCd +
            associatedCorpsTableCopy[i].facilityId + ' ' + assocItems.facilityId);
          // rule 1 if it exists in assoc corps table and assignedfacil lists, it already is assoc and can be discarded
          if (associatedCorpsTableCopy[i].blnktSlsOrderCd === assocItems.blnktSlsOrderCd &&
            associatedCorpsTableCopy[i].facilityId === assocItems.facilityId) {
            console.log('splicing');
            associatedCorpsTableCopy.splice(i, 1); // remove the item, it is already associated
            break;
          }
        }
      }
    } catch {
      console.log('associatedCorpsTableCopy is empty');
    }
    // what is left is what will be associated
    console.log('whats left? ' + JSON.stringify(associatedCorpsTableCopy));

    /**
     * // check checklist against the left hand side table, if the checklist value does not appear in the left hand side table,
     * it has been disassociated and should be added to the remove list for removal
     */
    try {
      for (let i = assignedFacilitiesToCorpsListCopy.length - 1; i >= 0; i--) {
        console.log(assignedFacilitiesToCorpsListCopy[i].blnktSlsOrderCd);
        for (const leftTableItem of this.assocCorpsTable) {
          console.log('why is it undefined? ' + assignedFacilitiesToCorpsListCopy[i].blnktSlsOrderCd + ' ' + leftTableItem.blnktSlsOrderCd +
            assignedFacilitiesToCorpsListCopy[i].facilityId + ' ' + leftTableItem.facilityId);
          // rule 1 if it exists in assoc corps table and assignedfacil lists, it already is assoc and can be discarded
          if (assignedFacilitiesToCorpsListCopy[i].blnktSlsOrderCd === leftTableItem.blnktSlsOrderCd &&
            assignedFacilitiesToCorpsListCopy[i].facilityId === leftTableItem.facilityId) {
            console.log('splicing');
            assignedFacilitiesToCorpsListCopy.splice(i, 1); // remove the item, it is already associated
            break;
          }
        }
      }
    } catch {
      console.log('assignedFacilitiesToCorpsListCopy is empty');
    }
    // whats left is what will be disassociated from the template
    console.log('whats left of assignedFacilitiesToCorpsListCopy ' + JSON.stringify(assignedFacilitiesToCorpsListCopy));

    // send the results into their proper payload lists for final delivery
    for (const corpItem of associatedCorpsTableCopy) {
      console.log(JSON.stringify(corpItem));
      this.updateListCorps.corpsAdded.push(corpItem.blnktSlsOrderCd);
      this.updateListCorps.facilitiesAdded.push(corpItem.facilityId);
    }
    for (const corpItem of assignedFacilitiesToCorpsListCopy) {
      console.log(JSON.stringify(corpItem));
      this.updateListCorps.corpsRemoved.push(corpItem.blnktSlsOrderCd);
      this.updateListCorps.facilitiesRemoved.push(corpItem.facilityId);
    }
    console.log('update list corps ' + JSON.stringify(this.updateListCorps));


  }

  saveButton() {
    console.log('save button pressed');
    this.toggleSaveButton = true; // immediately disable save button in case of duplicates
    this.updateRuleRequest.listCorpRuleContextAdd = []; // reset
    this.updateRuleRequest.contexts_reject = []; // reset
    this.updateRuleRequest.contexts_retire = []; // reset

    let removeCorps = '';

    // check the associations table, anything not in the contexts list must be disassociated
    try {
      for (const context of this.ruleContexts) {
        // console.log(JSON.stringify(context));
        let contextFound = false;
        for (const association of this.assocCorpsTable) {
          // console.log(JSON.stringify(association));
          if (context.blnktSlsOrderCd === association.blnktSlsOrderCd) {
            contextFound = true;
            break;
          }
        }
        if (!contextFound) {
          removeCorps = removeCorps + context.blnktSlsOrderCd + ' ';
          // set date to now if the rule is already approved
          if (this.data.templateData.status === 'Approved') {
            this.updateRuleRequest.contexts_retire.push(context.ruleContextId);
          } else {
            this.updateRuleRequest.contexts_reject.push(context.ruleContextId);
          }
        }
      }
    } catch {
      console.warn('rulecontexts is not iterable');
    }
    console.log(JSON.stringify(this.updateRuleRequest));

    // push associations to table
    for (const item of this.assocCorpsTable) {
      // check the context list for duplicates
      // console.log(JSON.stringify(item));
      let contextFound = false;
      try {
        for (const context of this.ruleContexts) {
          // console.log(JSON.stringify(context));
          if (item.blnktSlsOrderCd === context.blnktSlsOrderCd) {
            contextFound = true;
            break;
          }
        }
      } catch {
        console.warn('ruleContexts not iterable');
      }
      if (contextFound) {
        // console.log('found for ' + item.blnktSlsOrderCd);
        // do not add to any list, skip
      } else {
        // console.log(JSON.stringify(item.blnktSlsOrderCd));
        // add items to a context add
        const contextAdd = {
          blnktSlsOrderCd: '',
          clientId: 0,
          facilityId: 0,
          fromDt: null,
          toDt: null,
        };
        contextAdd.blnktSlsOrderCd = item.blnktSlsOrderCd;
        contextAdd.clientId = item.clientId;

        // set date to now if the rule is already approved
        if (this.data.templateData.status === 'Approved') {
          contextAdd.fromDt = this.transformDate(new Date());
        }

        // convert the facility code to an id
        contextAdd.facilityId = null;
        for (const facility of this.facilitiesToHold) {
          if (facility.facilityCd === item.facilityCd) {
            contextAdd.facilityId = facility.facilityId;
            break;
          }
        }
        // do not allow facility id to be null
        // if (contextAdd.facilityId === null) {
        //   console.warn('facility Id is null');
        //   this.popupWarning(false, '', 'Facility is not available');
        //   return;
        // }
        // contextAdd.facilityId = item.facilityCd;
        this.updateRuleRequest.listCorpRuleContextAdd.push(contextAdd);
      }
    }
    // set the rule name and description
    this.updateRuleRequest.ruleNm = this.ruleName;
    this.updateRuleRequest.ruleDesc = this.ruleDescription;
    console.log(JSON.stringify(this.updateRuleRequest));

    // list of corps
    let addedCorps = '';
    const rejectedCorps = '';
    for (const corp of this.updateRuleRequest.listCorpRuleContextAdd) {
      addedCorps = addedCorps + corp.blnktSlsOrderCd + ' ';
    }
    for (const corp of this.updateRuleRequest.contexts_reject) {
      // rejectedCorps.push(corp);
    }

    // check the corp list and if any are already associate them, put them in a list and ask the user if
    // they want to remove from old rule and add to new rule
    // do not add to corpsList if it is already associated!
    const corpsList = [];
    console.log(JSON.stringify(this.ruleContexts));
    for (const item of this.assocCorpsTable) {
      const associatedCorp = this.ruleContexts.find(
        x => x.blnktSlsOrderCd === item.blnktSlsOrderCd);
      // if undefined, it is not associated and therefore can go into the list
      try {
        if (associatedCorp.blnktSlsOrderCd === item.blnktSlsOrderCd) {
          // do not push, already associated
        } else {
          corpsList.push(item.blnktSlsOrderCd);
        }
      } catch { // undefined not associated
        corpsList.push(item.blnktSlsOrderCd);
      }
    }
    console.log(JSON.stringify(corpsList) + ' ' + JSON.stringify(this.updateRuleRequest));
    this.serviceGetContextsByStatus(corpsList, this.updateRuleRequest, addedCorps, removeCorps);


    // this.popupWarning(true, '', 'For this template: ' + this.ruleName + '\n\n' + 'Associated corps: '
    //   + addedCorps + '\n\n' + 'Disassociated corps: '
    //   + removeCorps);

    // this.popupDialogRef.afterClosed().subscribe(result => {
    //   if (result === true) {

    //     // finally, save the results and lock the form
    //     // this.serviceSaveRuleContexts(this.updateRuleRequest, addedCorps, removeCorps);

    //   } else {
    //     console.log('NO');
    //   }
    // });


  }

  // saveButton() { // set any array that has no values to null
  //   console.log('SAVE BUTTON ' + JSON.stringify(this.updateListCorps));
  //   let AsscCorps = this.updateListCorps.corpsAdded;
  //   let DiscCorps = this.updateListCorps.corpsRemoved;

  //   this.submitProcessing();

  //   if (AsscCorps === null) { AsscCorps = ['None']; } // display none instead of null
  //   if (DiscCorps === null) { DiscCorps = ['None']; }
  //   this.popupWarning(true, '', 'For this template: ' + this.templateDesc + '\n\n' + 'Associated corps: '
  //     + AsscCorps + '\n\n' + 'Disassociated corps: ' + DiscCorps);

  //   this.popupDialogRef.afterClosed().subscribe(result => {
  //     if (result === true) {
  //       console.log('YES');
  //       if (this.updateListCorps.corpsRemoved.length === 0) {
  //         this.updateListCorps.corpsRemoved = null;
  //       }
  //       if (this.updateListCorps.corpsAdded.length === 0) {
  //         this.updateListCorps.corpsAdded = null;
  //       }
  //       if (this.updateListCorps.detailsUpdated.length === 0) {
  //         this.updateListCorps.detailsUpdated = null;
  //       }
  //       if (this.updateListCorps.detailsRemoved.length === 0) {
  //         this.updateListCorps.detailsRemoved = null;
  //       }
  //       if (this.updateListCorps.detailsAdded.length === 0) {
  //         this.updateListCorps.detailsAdded = null;
  //       }
  //       if (this.updateListCorps.facilitiesAdded.length === 0) {
  //         this.updateListCorps.facilitiesAdded = null;
  //       }
  //       if (this.updateListCorps.facilitiesRemoved.length === 0) {
  //         this.updateListCorps.facilitiesRemoved = null;
  //       }

  //       console.log(JSON.stringify(this.updateListCorps));
  //       // this.serviceUpdateTemplate(this.updateListCorps);
  //       this.toggleSaveButton = !this.toggleSaveButton;
  //       this.toggleAsscButton = !this.toggleAsscButton;
  //       this.toggleDiscButton = !this.toggleDiscButton;
  //       this.saveOccured = true;
  //       this.saveStatus = true;
  //     } else {
  //       console.log('NO');
  //     }
  //   });
  // }

  cancelButton() {
    // restore the template id in session storage when returning properly
    sessionStorage.setItem('templateId', this.data.templateData.templateId);
    // this.dialogRef.close();
    window.close();
  }

  popupWarning(questionType, title?, message?) {
    this.popupDialogRef = this.dialog.open(GenericPopupComponent, {
      // minWidth: '300px',
      maxWidth: 'auto',
      maxHeight: 'auto',
      panelClass: 'popup-borders',
      data: {
        questionType,
        textAreaText: true,
        title,
        message
      }
    });
    return true;
    // return finalResult;
  }

  openDialog(title, message) {
    const dialogRef = this.dialog.open(GenericPopupComponent, {
      width: '450px',
      data: {
        message,
        title
      },
      maxWidth: '500px',
      maxHeight: '500px',
      panelClass: 'popup-borders'
    });
  }

  loadTableComponent() { // load table component features and preliminary data
    // read only vs view only mode
    if (sessionStorage.getItem('listCorpView') === 'viewOnly') {
      this.columns = [
        { columnDef: 'blnktSlsOrderCd', header: 'Corp', cell: (element: any) => `${element.blnktSlsOrderCd}` },
        { columnDef: 'clientNm', header: 'Client', cell: (element: any) => `${element.clientNm}` },
      ];
      this.displayedColumns = this.columns.map(c => c.columnDef);
      this.reusableTable0.disableCheckboxesColumn = true;
    } else {
      this.reusableTable0.disableCheckboxesColumn = false;
    }
    // this.reusableTable0.disableIndexColumn = false;
    // this.reusableTable0.enableSelectableRows = true;
    this.reusableTable0.matTooltip = 'Select a corp to disassociate';
    // this.reusableTable0.dataSource.data = [{
    //   'blnktSlsOrderCd': 'corp',
    //   'blnktSlsOrderDesc': 'detail', 'clientNm': 'client1'
    // },
    // { 'blnktSlsOrderCd': 'corp2', 'blnktSlsOrderDesc': 'detail', 'clientNm': 'client2' }];

    this.reusableTable1.disableCheckboxesColumn = false;
    // this.reusableTable1.disableIndexColumn = false;
    this.reusableTable1.enableSelectableRows = false;
    this.reusableTable1.matTooltip = 'Select a corp to associate';
  }

  // loadToCorpComponent() {
  //   this.toCorpComponent.fromElement = false;
  // }

  updateBsoCodes(tableRowData) {
    // add bso code to the corps removed array in updateListCorps
    let matchFound = false;
    if (this.updateListCorps.corpsRemoved.length === 0) {
      this.updateListCorps.corpsRemoved.push(tableRowData.blnktSlsOrderCd);
      console.log('UPDATE LIST CORPS REMOVED ' + JSON.stringify(this.updateListCorps.corpsRemoved));
    } else {
      for (const item of this.updateListCorps.corpsRemoved) {
        if (item === tableRowData.blnktSlsOrderCd) {
          console.log(item);
          console.log(tableRowData.blnktSlsOrderCd);
          matchFound = true;
        }
      }
      if (!matchFound) {
        this.updateListCorps.corpsRemoved.push(tableRowData.blnktSlsOrderCd);
        console.log('UPDATE LIST CORPS REMOVED ' + JSON.stringify(this.updateListCorps.corpsRemoved));
      }
    }
  }

  // methods for getting data from reusable components
  receiveMessage($event) {
    this.message = $event;
    console.log('I RECEIVED func0 ' + JSON.stringify(this.message));
  }

  table1ReceiveMessage($event) {
    if (this.reusableTable1.enableSelectableRows) { // selectable single row, requires as list
      const listItem = [];
      listItem.push($event);
      this.table1rowData = listItem;
    } else if (!this.reusableTable1.disableCheckboxesColumn) { // already a list
      this.table1rowData = $event;
    }
    console.log('I RECEIVED func1 ' + JSON.stringify(this.table1rowData));
  }

  table0ReceiveMessage($event) {
    this.table0rowData = $event;
    console.log('I RECEIVED func2 ' + JSON.stringify(this.table0rowData));
  }

  fromReceiveMessage($event) {
    if (typeof $event === 'object') {
      this.fromCorp = $event.blnktSlsOrderCd;
    } else {
      this.fromCorp = $event;
    }
    console.log('FROM SEARCH RECEIVED ' + JSON.stringify(this.fromCorp));
    this.serviceGetCorps(this.fromCorp, this.searchClientId, true);
  }

  toReceiveMessage($event) {
    if (typeof $event === 'object') {
      this.toCorp = $event.blnktSlsOrderCd;
    } else {
      this.toCorp = $event;
    }
    console.log('TO SEARCH RECEIVED ' + JSON.stringify(this.toCorp));
    this.serviceGetCorps(this.toCorp, this.searchClientId, false);
  }

  searchReceiveMessage($event) {
    this.searchMessage = $event;
    console.log('CLIENT SEARCH RECEIVED ' + JSON.stringify(this.searchMessage));
    console.log(this.searchComponent.searchControl.status);
    if (this.searchComponent.searchControl.status !== 'INVALID') {
      this.serviceGetClientsByName(this.searchMessage);
    }
    // this.serviceGetClientsByName(this.searchMessage);
  }

  receiveMessageObj($event) { // assigns client id and client name
    this.messageObject = $event;
    console.log(JSON.stringify('RECEIVE MESSAGE OBJECT ' + JSON.stringify(this.messageObject)));
    try {
      if (this.messageObject.clientId.length <= 0 || this.messageObject.clientNm.length <= 0) {
        console.log('return was undefined, length of zero');
        this.searchClientId = 'null';
        this.clientName = 'null';
      } else {
        console.log('return was good');
        this.searchClientId = this.messageObject.clientId;
        this.clientName = this.messageObject.clientNm;
      }
    } catch {
      console.log('return was undefined, caught');
      this.searchClientId = 'null';
      this.clientName = 'null';
    }
    // this.searchClientId = this.messageObject.clientId;
    // this.clientName = this.messageObject.clientNm;
  }
  // end of getting data methods

  // facilities methods
  selectAll() {
    // this.toggleAllSelected = !this.toggleAllSelected;
    this.selectedFacilityId = null;
    this.facilityIdSearchValue = null;
    if (this.toggleAllSelected === true) {
      this.facilityIds = ['null'];
      // sessionStorage.setItem('facilityIds', 'null');
      // enable material
      // this.materialControl.enable();
      // this.serviceGetInsertDetails('00050837', this.facilityIds);
    } else {
      this.facilityIds = [];
      // this.materialControl.disable();
    }
    console.log(this.facilityControl.value);
  }

  facilityIdLookup(value, isClicked?) {
    console.log(isClicked);
    console.log('STATEIDLOOKUP ' + JSON.stringify(value));
    const facilityObject = value.toLowerCase();
    // find the state id, put it into array if it its not there (aka checked)
    for (const facility of this.facilitiesToHold) {
      if (
        facilityObject === facility.facilityId.toLowerCase() ||
        facilityObject === facility.facilityNm.toLowerCase() ||
        facilityObject === facility.facilityCd.toLowerCase()
      ) {
        const id = this.facilityIds.find(x => x === facility.facilityId);
        this.selectedFacilityId = id;
        if (isClicked === 'true') { // this value should not be affected by the search
          this.facilityIdSearchValue = id;
        }
        if (id === undefined) {
          this.selectedFacilityId = facility.facilityId;
          if (isClicked === 'true') {
            this.facilityIdSearchValue = facility.facilityId;
          }
          this.facilityIds.push(facility.facilityId);
          // remove id if it is already in the array (aka unchecked)
        } else {
          console.log('X IS ' + id);
          const index = this.facilityIds.indexOf(id);
          // console.log('INDEX IS ' + index);
          this.facilityIds.splice(index, 1);
        }
      }
    }
    console.log('FACILITY CODES IS ' + this.facilityIds);
    const facilityIds = this.facilityIds.join('-');
    // sessionStorage.setItem('facilityIds', facilityIds);
    if (this.facilityIds.length === 0) {
      // this.materialControl.disable();
    } else {
      // this.materialControl.enable();
      // this.serviceGetInsertDetails('00050837', this.facilityIds);
    }
    return this.selectedFacilityId;
  }
  // end of facilities methods

  // this method gets the non-generic key name and sets it to be generic. when outgoing will switch back to non-generic
  genericizeData() {
    if (this.data.moduleName === 'modulePH') {
      // prehold non generics
      this.data.templateData.templateId = this.data.templateData.preholdTemplateId;
      this.data.templateData.templateDesc = this.data.templateData.preholdTemplateDesc;
      if (this.data.templateData.templateId === '') { this.popupWarning(false, 'Alert', 'missing template ID'); }
    } else if (this.data.moduleName === 'moduleDM') {
      // delayed mail non generics
      this.data.templateData.templateId = this.data.templateData.delayedmailTemplateId;
      this.data.templateData.templateDesc = this.data.templateData.delayedmailTemplateDesc;
    } else if (this.data.moduleName === 'modulePS') {
      // production setup non-generics
      this.data.templateData.templateId = this.data.templateData.productionTemplateId;
      this.data.templateData.templateDesc = this.data.templateData.productionTemplateDesc;
    } else if (this.data.moduleName === 'modulePT') {
      // plan template non-generics
      this.data.templateData.templateId = this.data.templateData.planTemplateId;
      this.data.templateData.templateDesc = this.data.templateData.planTemplateDesc;
    } else if (this.data.moduleName === 'modulePM') {
      // prod method group non-generics
      this.data.templateData.templateId = this.data.templateData.prodmethodgroupTemplateId;
      this.data.templateData.templateDesc = this.data.templateData.prodmethodgroupTemplateDesc;
    } else if (this.data.moduleName === 'modulePA') {
      // prod method group non-generics
      this.data.templateData.templateId = this.data.templateData.packageTemplateId;
      this.data.templateData.templateDesc = this.data.templateData.packageTemplateDesc;
    }
  }

  downloadCsv() {
    // make new json with flattened selected values
    const copyItems = [];
    let items = [];
    items = this.reusableTable0.dataSource.data;

    if (items.length == 0) {
      this.popupWarning(false, 'Alert', 'Export did not find any associated corps.');
    } else {
      for (const item of items) {
        const tempObj = {
          Corp: '',
          // Facility: '',
          // Description: '',
          Client: '',
        };
        // console.log(JSON.stringify(item));
        tempObj.Corp = item.blnktSlsOrderCd;
        // tempObj.Facility = item.facilityCd;
        // tempObj.Description = item.blnktSlsOrderDesc;
        tempObj.Client = item.clientNm;
        copyItems.push(tempObj);
      }
      // console.log(JSON.stringify(copyItems));

      // convert json to csv
      const replacer = (key, value) => value === null ? '' : value;
      const header = Object.keys(copyItems[0]);
      const csv = copyItems.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
      csv.unshift(header.join(','));
      // csv.unshift('sep=,');
      // csv.unshift({Template: this.templateDesc}); // place the tempalte name within the csv
      let finalCsv = JSON.stringify(csv);
      finalCsv = csv.join('\r\n');
      // console.log(finalCsv);
      finalCsv = finalCsv.replace(/\\"/g, '""');
      finalCsv = 'Rule Name: ' + this.ruleName + '\n' + finalCsv;
      const csvFile = finalCsv;
      // console.log(finalCsv);

      const blob = new Blob([csvFile], { type: 'text/csv' });
      saveAs(blob, 'Table.csv');
    }
  }

  // date transformation methods
  humanReadableDate(date) {
    if (date === null || date === '' || date === undefined || date === 'undefined') {
      return '';
    }
    if (date.indexOf('/') !== -1) {
      console.log('is a proper date');
      return date;

    } else {
      console.log('is a database style date');
      console.log(date);
      date = (date as string).slice(0, 8);
      date = (date as string).slice(0, 2) + // rebuild the date in a human readable format
        '/' + (date as string).slice(2, 4) +
        '/' + (date as string).slice(4, 8);

      console.log(date);
      return date;
    }

  }

  humanReadableToDatabase(date: string) { // convert a human readable date to a database stored type
    date = date.replace(/\//gm, '');
    date += '000000';
    console.log(date);
    if (date === '000000' || date === null || date === 'null') { // no date provided
      return '';
    } else {
      return date;
    }
  }

  transformDate(controlDate) { // transform date from control full style date to database style date
    console.log('CONTROL DATE IS ' + controlDate);
    const date: Date = controlDate;
    console.log(date);
    let dateString = '';
    if (date !== null && controlDate !== '') {
      dateString = ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + date.getFullYear();
    }
    dateString = dateString + '000000';
    console.log('DATE IS ' + dateString);
    if (dateString === 'aNaNNaN000000' || dateString === '000000') { // received no date
      return '';
    } else {
      return dateString;
    }
  }

  // utility methods
  sortByProperty(property1, property2?) {
    return (a, b) => {
      if (a[property1] > b[property1]) { return 1; }
      else if (a[property1] < b[property1]) { return -1; }

      if (a[property2] > b[property2]) { return 1; }
      else if (a[property2] < b[property2]) { return -1; }

      return 0;
    };
  }

  checkValue(value) {
    if (value === null) {
      return false;
    } else if (value === undefined) {
      return false;
    } else if (value === '') {
      return false;
    } else {
      return true;
    }
  }
}
